import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { SettingsScreen } from "../settings/SettingsScreen";
import { useScope } from "../auth/ScopeGate";

// File name matters: `_authed.settings.tsx` nests this under the _authed layout, so it gets the
// per-session query client and a resolved scope. A bare `settings.tsx` would generate a
// ROOT-level route with no ScopeGate above it, and useScope would throw.
export const Route = createFileRoute("/_authed/settings")({ component: SettingsRoute });

function SettingsRoute() {
  const scope = useScope();
  const navigate = useNavigate();

  // UX, not security: the server refuses a site manager on every /businesses/{id}/... call
  // this screen makes anyway (business-wide routes → StaffAccessRules refuses a SiteManager).
  // This just avoids showing them a screen made entirely of 403s.
  useEffect(() => {
    if (scope.role !== "Owner") void navigate({ to: "/" });
  }, [scope.role, navigate]);

  if (scope.role !== "Owner") return null;
  return <SettingsScreen businessId={scope.businessId} />;
}
